<template>
  <div class="col-12 pb-2 pb-md-5 filter-container">
    <StoCscFilterHeader />
    <StoCscFilterSectionRender addContainerClasses="pt-3" />
    <StoCscFilterSectionPinsulation addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionOuterPlanking addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionStand addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionCompartmentInsulation addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionInnerPlanking1 addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionInnerPlanking2 addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionInnerPlanking3 addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionSoundReductionIndex addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionHeatTransferCoefficient addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionFireResistanceInner addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionFireResistanceOuter addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionFireBehavior addContainerClasses="pt-3 border-top" />
  </div>
</template>

<script>

import StoCscFilterHeader from './Header.vue'
import StoCscFilterSectionRender from './Section/Render.vue'
import StoCscFilterSectionOuterPlanking from './Section/OuterPlanking.vue'
import StoCscFilterSectionInnerPlanking1 from './Section/InnerPlanking1.vue'
import StoCscFilterSectionInnerPlanking2 from './Section/InnerPlanking2.vue'
import StoCscFilterSectionInnerPlanking3 from './Section/InnerPlanking3.vue'
import StoCscFilterSectionStand from './Section/Stand.vue'
import StoCscFilterSectionCompartmentInsulation from './Section/CompartmentInsulation.vue'
import StoCscFilterSectionPinsulation from './Section/Pinsulation.vue'
import StoCscFilterSectionSoundReductionIndex from './Section/SoundReductionIndex.vue'
import StoCscFilterSectionHeatTransferCoefficient from './Section/HeatTransferCoefficient.vue'
import StoCscFilterSectionFireResistanceInner from './Section/FireResistanceInner.vue'
import StoCscFilterSectionFireResistanceOuter from './Section/FireResistanceOuter.vue'
import StoCscFilterSectionFireBehavior from './Section/FireBehavior.vue'

export default {
  name: 'StoCscFilterGrid',
  components: {
    StoCscFilterSectionRender,
    StoCscFilterSectionOuterPlanking,
    StoCscFilterSectionInnerPlanking1,
    StoCscFilterSectionInnerPlanking2,
    StoCscFilterSectionInnerPlanking3,
    StoCscFilterSectionStand,
    StoCscFilterSectionCompartmentInsulation,
    StoCscFilterHeader,
    StoCscFilterSectionPinsulation,
    StoCscFilterSectionSoundReductionIndex,
    StoCscFilterSectionHeatTransferCoefficient,
    StoCscFilterSectionFireResistanceInner,
    StoCscFilterSectionFireResistanceOuter,
    StoCscFilterSectionFireBehavior
  },
  mounted () {
    const scrollIntoView = this.$cookies.get('sto-dk-intoview')
    const el = document.querySelector('.filter-header')
    if (el && scrollIntoView) {
      el.scrollIntoView()
    }
    if (this.$cookies.get('cwcc_functional')) this.$cookies.set('sto-dk-intoview', true, 'Fri, 31 Dec 9999 23:59:59 GMT')
  }
}

</script>
